import { useEffect, useState } from "react";
import { Button } from "../components/ui/button";
import { useI18n } from "../lib/i18n";

const KEY = "vg_age_confirmed_v1";

export default function AgeGate() {
  const [open, setOpen] = useState(false);
  const { t } = useI18n();

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setOpen(true);
  }, []);

  if (!open) return null;

  const confirm = () => {
    localStorage.setItem(KEY, new Date().toISOString());
    setOpen(false);
  };
  const leave = () => { window.location.href = "https://www.google.com/"; };

  return (
    <div className="fixed inset-0 z-[100] bg-[#0B0E14]/95 backdrop-blur-xl flex items-center justify-center p-6" data-testid="age-gate">
      <div className="max-w-lg w-full border border-white/15 bg-[#151B28] p-8 sm:p-10 relative overflow-hidden">
        <div className="absolute inset-x-0 top-0 h-[2px] bg-[#2DD4A7]" />
        <div className="text-xs font-mono uppercase tracking-widest text-[#2DD4A7] mb-4">18/21+</div>
        <h2 className="font-display text-3xl sm:text-4xl font-black leading-tight mb-4">{t("age.title")}</h2>
        <p className="text-[#8B97AE] text-sm leading-relaxed mb-8">{t("age.body")}</p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Button data-testid="age-gate-confirm" onClick={confirm} className="rounded-none bg-[#2DD4A7] text-[#04150F] hover:bg-[#F5B841] hover:text-[#04150F] font-semibold h-12 px-6 flex-1 transition-colors">
            {t("age.confirm")}
          </Button>
          <Button data-testid="age-gate-leave" onClick={leave} variant="ghost" className="rounded-none border border-white/15 h-12 px-6 text-white hover:bg-white/10 transition-colors">
            {t("age.leave")}
          </Button>
        </div>
      </div>
    </div>
  );
}
